import { Card, CardContent, Stack, Typography } from '@mui/material';

export default function ProposalSectionCard({ title, icon: Icon, children }) {
    return (
        <Card variant="outlined">
            <CardContent>
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
                    {Icon ? <Icon color="primary" /> : null}
                    <Typography variant="h6" component="h2">
                        {title}
                    </Typography>
                </Stack>
                {children}
            </CardContent>
        </Card>
    );
}
